import _ from 'lodash'
import { createSelector } from 'reselect'
import { calculatePeriod } from 'core/service/basic-plan'
import { isNotNil } from 'core/service/lib/type-check'
import VALUES from 'core/data-model/constants/values'

import {
  getSelectedDisplayProductCoveragePeriod,
  getSelectedDisplayProductPaymentPeriod,
  getSelectedDisplayProduct,
} from 'quick-quote/product-selection/selectors'

import { getSelectedRiders } from 'quick-quote/product-common/coverage-plan/selectors'
import { isCheckRiderCampaignDiscountActive } from 'core/service/rider/rider'

import { getAge, getInsuredOccupationClass } from 'quick-quote/insured-information/selectors'
import { getUserAgentType } from 'identity/selectors'
import { christianToThaiDate } from 'core/service/lib/date'
import { isCheckBasicCampaignDiscountActive } from 'core/service/basic-plan/basic-plan'
import Mustache from 'mustache'

export const getCalculatedCoveragePeriod = createSelector(
  getSelectedDisplayProductCoveragePeriod,
  getAge,
  (coveragePeriod, age) => {
    const actualAge = age.unit !== 'year' ? 0 : _.get(age, 'value', 0)
    return calculatePeriod(coveragePeriod, actualAge)
  }
)

export const getCalculatedPaymentPeriod = createSelector(
  getSelectedDisplayProductPaymentPeriod,
  getAge,
  (paymentPeriod, age) => {
    const actualAge = age.unit !== 'year' ? 0 : _.get(age, 'value', 0)
    return calculatePeriod(paymentPeriod, actualAge)
  }
)

export const getHasShowDisclaimerRiderAsterisk = createSelector(getSelectedRiders, (selectedRiders) => {
  return isNotNil(
    selectedRiders.find(
      (rider) =>
        rider.premiumStructure === VALUES.PREMIUM_NON_LEVEL &&
        !VALUES.LIST_EXCEPT_ASTERISKS_BENEFIT_SUMMARY_TABLE.includes(rider.code)
    )
  )
})

export const getIsCheckBasicCampaignDiscountActive = createSelector(
  getSelectedDisplayProduct,
  getInsuredOccupationClass,
  getUserAgentType,
  (displayProduct, occupationClass, userAgentType) => {
    const isBasicCampaignDiscountActive = isCheckBasicCampaignDiscountActive({
      basicPlan: displayProduct,
      occupationFactor: occupationClass,
      userAgentType,
    })
    return isBasicCampaignDiscountActive
  }
)

export const getIsCheckRiderCampaignDiscountActive = createSelector(
  getSelectedRiders,
  getUserAgentType,
  (selectedRiders, userAgentType) => {
    const riderCampaignActive = selectedRiders.find((rider) => isCheckRiderCampaignDiscountActive(rider, userAgentType))
    return isNotNil(riderCampaignActive)
  }
)

export const getRiderCampaignDiscountProps = createSelector(
  getSelectedRiders,
  getUserAgentType,
  (selectedRiders, userAgentType) => {
    const filterRiderCampaignActive = selectedRiders.filter((rider) =>
      isCheckRiderCampaignDiscountActive(rider, userAgentType)
    )
    const riderCampaignDiscountProps =
      filterRiderCampaignActive.length > 0
        ? filterRiderCampaignActive.map((r) => {
            return { code: r.code, campaignDiscount: r.campaignDiscount }
          })
        : []
    return riderCampaignDiscountProps
  }
)

export const getMappingRiderCampaignDiscountBIMessage = createSelector(
  getIsCheckRiderCampaignDiscountActive,
  getRiderCampaignDiscountProps,
  (isCheckRiderCampaignDiscountActive, riderCampaignDiscountProps) => {
    const result = []
    if (isCheckRiderCampaignDiscountActive) {
      riderCampaignDiscountProps.map((rider) => {
        result.push(
          Mustache.render(_.get(rider.campaignDiscount.campaignDiscountMessage, 'biInformationMessage'), {
            campaignStartDate: _.get(rider.campaignDiscount, 'startDate')
              ? christianToThaiDate(_.get(rider.campaignDiscount, 'startDate'), 'DD/MM/YYYY')
              : '',
            campaignEndDate: _.get(rider.campaignDiscount, 'endDate')
              ? christianToThaiDate(_.get(rider.campaignDiscount, 'endDate'), 'DD/MM/YYYY')
              : '',
          })
        )
      })
    }
    return result
  }
)
